import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import NewsEditComponent from "../../components/News/NewsEditComponent";
import { AlertContext } from "../../util/Alerter";


const AdminActualiteEdit = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const { showAlert } = useContext(AlertContext)
  const [newsDetails, setnewsDetails] = useState("");


  const ACTUALITY_DETAILS_URL = Global.backend + "/index.php/actualite/show";

  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("modifyNews")
    setalertTitle("")
    setnavLinks([{ path: "/dashboard/admin/adminactualitelist", label: "navigation8.1" }])
  }, [])


  useEffect(() => {
    setisLoading(true)

    axios.post(ACTUALITY_DETAILS_URL, { actualiteId: id }).then((response) => {
      setnewsDetails(response.data)
    }).catch(() => {
      showAlert("error", t("request.errorFetchingNewsDetails"))
    }).finally(() => {
      setisLoading(false)
    })
  }, []);







  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !newsDetails ? <NotFound /> : <NewsEditComponent newsData={newsDetails} />
      )}
    </LoaderComponent>
  );
};

export default AdminActualiteEdit;
